/**
 * @flow
 * @relayHash 6b71c795393656c98f6615d060d5d474
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DownPaymentDistribution = "FIXED" | "PERCENT" | "%future added value";
export type PplanDistributionEnum = "EQUAL" | "FIXED" | "PERCENT" | "%future added value";
export type PplanStatusEnum = "INITIAL" | "PAID" | "%future added value";
export type UpdateIPplanInput = {
  clientMutationId?: ?string,
  invoice_id: string,
  down_payment_cents?: ?number,
  down_payment_currency?: ?string,
  down_payment_distribution_type?: ?DownPaymentDistribution,
  down_payment_due_at?: ?any,
  down_payment_percent?: ?number,
  pplan_distribution_type?: ?PplanDistributionEnum,
  pplan_items?: ?$ReadOnlyArray<?PplanItemInput>,
  delete_pplan_items_with_ids?: ?$ReadOnlyArray<?string>,
};
export type PplanItemInput = {
  id?: ?string,
  due_at?: ?any,
  amount_cents?: ?number,
  amount_currency?: ?string,
};
export type PaymentPlan_Invoice_updateIPplanMutationVariables = {|
  input: UpdateIPplanInput
|};
export type PaymentPlan_Invoice_updateIPplanMutationResponse = {|
  +updateIPplan: ?{|
    +invoice: ?{|
      +down_payment_cents: ?number,
      +down_payment_due_at: ?any,
      +down_payment_percent: ?number,
      +down_payment_currency: ?string,
      +down_payment_distribution_type: ?DownPaymentDistribution,
      +pplan_distribution_type: ?PplanDistributionEnum,
      +i_pplan_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +amount_cents: ?number,
            +amount_currency: ?string,
            +due_at: ?any,
            +id: string,
            +locked: ?boolean,
            +percent: ?number,
            +status: ?PplanStatusEnum,
          |}
        |}>
      |},
    |}
  |}
|};
export type PaymentPlan_Invoice_updateIPplanMutation = {|
  variables: PaymentPlan_Invoice_updateIPplanMutationVariables,
  response: PaymentPlan_Invoice_updateIPplanMutationResponse,
|};
*/


/*
mutation PaymentPlan_Invoice_updateIPplanMutation(
  $input: UpdateIPplanInput!
) {
  updateIPplan(input: $input) {
    invoice {
      down_payment_cents
      down_payment_due_at
      down_payment_percent
      down_payment_currency
      down_payment_distribution_type
      pplan_distribution_type
      i_pplan_items {
        edges {
          node {
            amount_cents
            amount_currency
            due_at
            id
            locked
            percent
            status
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateIPplanInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateIPplanInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "down_payment_cents",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "down_payment_due_at",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "down_payment_percent",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "down_payment_currency",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "down_payment_distribution_type",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pplan_distribution_type",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "i_pplan_items",
  "storageKey": null,
  "args": null,
  "concreteType": "IPplanItemConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "IPplanItemEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "IPplanItem",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount_cents",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "amount_currency",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "due_at",
              "args": null,
              "storageKey": null
            },
            v8,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "locked",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "percent",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "status",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "PaymentPlan_Invoice_updateIPplanMutation",
  "id": null,
  "text": "mutation PaymentPlan_Invoice_updateIPplanMutation(\n  $input: UpdateIPplanInput!\n) {\n  updateIPplan(input: $input) {\n    invoice {\n      down_payment_cents\n      down_payment_due_at\n      down_payment_percent\n      down_payment_currency\n      down_payment_distribution_type\n      pplan_distribution_type\n      i_pplan_items {\n        edges {\n          node {\n            amount_cents\n            amount_currency\n            due_at\n            id\n            locked\n            percent\n            status\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "PaymentPlan_Invoice_updateIPplanMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateIPplan",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateIPplanPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v9
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PaymentPlan_Invoice_updateIPplanMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateIPplan",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateIPplanPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "invoice",
            "storageKey": null,
            "args": null,
            "concreteType": "Invoice",
            "plural": false,
            "selections": [
              v2,
              v3,
              v4,
              v5,
              v6,
              v7,
              v9,
              v8
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '41a9c4b4fd6570c6209225e6e973cde9';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/__generated__/PaymentPlan_Invoice_updateIPplanMutation.graphql.js